import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Popup } from 'semantic-ui-react';
import DatasetStatusPopup from './DatasetStatusPopup';
import { datasetStatusIcons } from '../constants';

const DatasetStatusButton = ({
  disabled,
  icon,
  onClick,
  reasons,
  status,
  supported,
  url,
}) => {
  const intl = useIntl();
  const message = supported ? `dataset.${status}.yes.text` : `dataset.${status}.no.text`;
  const disable = disabled || !supported;
  return (
    <Popup
      flowing
      position="left center"
      className="aridhia-status-button-popup"
      trigger={(
        <Button
          className="aridhia-status-button"
          positive={supported}
          negative={!supported}
          as={disable ? undefined : 'a'}
          href={disable ? undefined : url}
          content={icon ? undefined : intl.formatMessage({ id: message })}
          onClick={disable ? undefined : onClick}
          basic
          icon={datasetStatusIcons[status]}
        />
            )}
    >
      <DatasetStatusPopup reasons={reasons} status={status} />
    </Popup>
  );
};

export default DatasetStatusButton;
